import React from 'react';

import { PaymentStatusEnum } from 'v3/pages/OnlineContracting/Details/Cards/TransactionInformation/PaymentStatus/enum';
import { StatusDot, StatusValueContainer } from 'v3/pages/OnlineContracting/Details/Cards/styles';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { theme } from 'v3/styles/global-styles';

const getPaymentStatusColor = (status?: string): string => {
  switch (status) {
  case PaymentStatusEnum.Paid:
    return theme.palette.green.main;
  case PaymentStatusEnum.WaitingPayment:
    return theme.palette.warning.main;
  case PaymentStatusEnum.Denied:
  case PaymentStatusEnum.Canceled:
  case PaymentStatusEnum.PartialRefund:
  case PaymentStatusEnum.TotalRefund:
    return theme.palette.tertiary.main;
  default:
    return theme.palette.secondary.light;
  }
};

interface IPaymentStatusProps {
  status?: string;
}

export const PaymentStatus: React.FC<IPaymentStatusProps> = ({ status }) => {
  return (
    <StatusValueContainer>
      <StatusDot color={getPaymentStatusColor(status)} />
      <BodySmallRegular className="empty-line">{status || ''}</BodySmallRegular>
    </StatusValueContainer>
  );
};
